import React from "react";
import uuid from "react-uuid";
import Item from "../Item";
import { IVersion } from "../../../utils/fetchers/types";

type TListItems = {
  client: string,
  versions: IVersion[];
  currentVersion: string,
}

const ListItems: React.FC<TListItems> = ({ client, versions, currentVersion }) => {
  return (
    <>
      {
        versions.map((item) =>
          <Item
            currentVersion={currentVersion}
            key={uuid()}
            version={item}
            client={client}
          />)
      }
    </>
  );
};

export default ListItems;